import { useEffect, useState } from "react";
import axios from "axios";
import api, { apiErr } from "@/lib/api";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { DateInput } from "@/components/DateInput";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const card = "bg-white rounded-[16px] p-6 shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-slate-100";
const FIELDS = [
  ["nome", "Denominação social *", 2], ["nif", "NIF / NIPC *"], ["foro", "Foro (comarca) *", 1, "ex.: Lisboa"], ["morada", "Sede *", 2],
  ["email", "Email de privacidade *", 1, "suporte@imodesk.pt"], ["suporte", "Email de suporte *", 1, "suporte@imodesk.pt"],
  ["suporte_whatsapp", "WhatsApp de suporte (botão «? Ajuda»)", 1, "ex.: 351 912 345 678"],
  ["prazo_registos", "Prazo dos registos de acesso *", 1, "ex.: 12 meses"], ["prazo_demo", "Prazo dos pedidos de demonstração *", 1, "ex.: 12 meses"],
  ["publicado_em", "Data de publicação *", 1, "", "date"], ["dpo", "Encarregado de proteção de dados (opcional)"],
  ["limite", "Limite de responsabilidade (opcional · texto revisto pelo advogado)", 2],
];

export function LegalDefinicoes() {
  const [f, setF] = useState(null);
  const [complete, setComplete] = useState(false);
  useEffect(() => { axios.get(`${API}/public/legal`).then(({ data }) => { setF((cur) => cur || data.company); setComplete(data.complete); }); }, []);
  if (!f) return null;
  const save = async () => {
    try {
      const { data } = await api.put("/platform/legal", f);
      setF(data.company); setComplete(data.complete); toast.success("Dados da empresa guardados");
    } catch (e) { toast.error(apiErr(e.response?.data?.detail)); }
  };
  return (
    <div className={`${card} max-w-3xl`} data-testid="legal-settings">
      <h3 className="font-heading text-lg text-ec-green">Empresa ImoDesk (Termos e Privacidade)</h3>
      <p className="text-sm text-slate-500 mb-1">Aparece nas páginas /termos e /privacidade e no rodapé do site.</p>
      <p className={`text-xs font-semibold mb-5 ${complete ? "text-green-700" : "text-amber-700"}`} data-testid="legal-settings-status">
        {complete ? "Completo · páginas publicadas e indexáveis" : "Incompleto · páginas em «Versão provisória» e fora do Google"}
      </p>
      <div className="grid sm:grid-cols-2 gap-4">
        {FIELDS.map(([k, label, span, ph, type]) => (
          <div key={k} className={span === 2 ? "sm:col-span-2" : ""}>
            <Label htmlFor={`legal-${k}`}>{label}</Label>
            {type === "date"
              ? <DateInput value={f[k] || ""} onChange={(e) => setF({ ...f, [k]: e.target.value })} className="mt-1.5" data-testid={`legal-${k}`} />
              : <Input id={`legal-${k}`} value={f[k] || ""} placeholder={ph || ""} onChange={(e) => setF({ ...f, [k]: e.target.value })} className="mt-1.5" data-testid={`legal-${k}`} />}
          </div>
        ))}
        <label className="sm:col-span-2 flex items-center justify-between gap-3 text-sm text-slate-600 rounded-lg bg-slate-50 px-3 py-2.5">
          A base de dados e os ficheiros estão alojados na União Europeia (só ativar quando for verdade)
          <Switch checked={!!f.ue} onCheckedChange={(ue) => setF({ ...f, ue })} data-testid="legal-ue" />
        </label>
      </div>
      <button onClick={save} className="mt-5 bg-ec-green text-white px-5 py-2.5 rounded-lg font-semibold hover:bg-ec-greenDark transition-colors" data-testid="legal-save">Guardar</button>
    </div>
  );
}
